<template>
  <div class="ag-flex-container" :style="computedStyle">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: [String, Number],
      default: '100%',
    },

    direction: {
      type: String,
      default: 'column',
      validator: (direciton) => ['column', 'row'].includes(direciton),
    },

    align: {
      type: String,
      default: 'flex-start',
      validator: (direciton) => ['flex-start', 'flex-end', 'stretch', 'center'].includes(direciton),
    },

    justify: {
      type: String,
      default: 'flex-start',
      validator: (direciton) => ['flex-start', 'flex-end', 'stretch', 'center', 'space-between'].includes(direciton),
    },

    gap: {
      type: [String, Number],
      default: 0,
    },

    padding: {
      type: [String, Number],
      default: 0,
    },
  },

  computed: {
    computedStyle() {
      return `
          width: ${typeof this.width === 'number' ? `${this.width}px` : this.width};
          display: flex;
          flex-direction: ${this.direction};
          align-items: ${this.align};
          justify-content: ${this.justify};
          gap: ${typeof this.gap === 'number' ? `${this.gap}px` : this.gap};
          padding: ${typeof this.padding === 'number' ? `${this.padding}px` : this.padding};
        `;
    },
  },
};
</script>
